import { Component, ElementRef, EventEmitter, Inject, Input, Output, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core'
import { PdpGalleryService } from '../../services/pdp-gallery.service'
import { GalleryImageData } from '../../../models'
import { isPlatformBrowser } from '@angular/common'
import { UcService } from '../../../cms/enums/uc-service'

@Component({
  selector: 'mb-pdp-gallery-carousel',
  templateUrl: './pdp-gallery-carousel.component.html',
  styleUrls: ['./pdp-gallery-carousel.component.scss']
})
export class PdpGalleryCarouselComponent {

  activeImgIndex: number = 0

  @Input() set activeImageIndex (value: number) {
    this.activeImgIndex = value
  }

  imagesObject: GalleryImageData[] = []

  get imagesData () {
    return this.imagesObject
  }

  @Input() set imagesData (value: GalleryImageData[]) {
    this.imagesObject = value
  }

  @Input() videoThumbnails: GalleryImageData[] = []

  @Output() activeImage = new EventEmitter<GalleryImageData>()

  galleryCarousel: ElementRef | null = null

  @ViewChild('galleryCarousel') set galleryCarouselContent (content: ElementRef) {
    this.galleryCarousel = content
    if (this.activeImgIndex) {
      const children: any[] = Array.from(this.galleryCarousel?.nativeElement?.children)
      const activeImage: any = children?.find((child: any) => child?.classList.contains('mb-carousel-active-image'))
      const activeImageElement: any = activeImage?.children?.[0]
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => activeImageElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        }), 1000)
      }
    }
  }

  constructor (protected renderer: Renderer2,
               protected pdpGalleryService: PdpGalleryService,
               @Inject(PLATFORM_ID) protected platformId: string) {
  }

  onCarouselCaretClick (isScrollingUp: boolean): void {
    const scrollValue: number = 50

    if (isScrollingUp) {
      const value = this.galleryCarousel?.nativeElement.scrollTop - scrollValue
      this.renderer.setProperty(this.galleryCarousel?.nativeElement, 'scrollTop', value.toString())
    } else {
      const value = this.galleryCarousel?.nativeElement.scrollTop + scrollValue
      this.renderer.setProperty(this.galleryCarousel?.nativeElement, 'scrollTop', value.toString())
    }
  }

  onGalleryImageClick (image: GalleryImageData, index: number): void {
    this.activeImage.emit(image)
    this.activeImgIndex = index
  }

  getThumbnail (videoId: string): GalleryImageData | undefined {
    return this.pdpGalleryService.getThumbnail(videoId, this.videoThumbnails)
  }

  readonly ucService = UcService
}
